// extracted by mini-css-extract-plugin
export default {"formInput__title":"FormInput_formInput__title__xK34Y","formInput__input":"FormInput_formInput__input__kLM0R","error":"FormInput_error__F8h51"};